import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  statsRow: {
    width: '100%',
    display: 'grid',
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gap: 8,
    },
  },
  positionRow: {
    ...dFlex('space-between', 'end'),
    width: '100%',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: 8,
    },
  },
  tokensWeight: {
    [theme.breakpoints.down(Breakpoint.Sm)]: {
      width: '100%',
    },
  },
  tokenWeight: {
    [theme.breakpoints.down(Breakpoint.Sm)]: {
      width: '100%',
    },
  },
  priceImpactRow: {
    ...dFlex('end'),
    gap: 4,
    marginLeft: 'auto',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      justifyContent: 'center',
    },
  },
  loader: {
    width: 70,
  },
  text: {
    textWrap: 'nowrap',
  },
}));

export default useStyles;
